import { useTranslation } from 'react-i18next'
import './product-availability.scss'

interface AvailabilityDate { start_date: string, end_date: string }

function formatDate(date: string | undefined, noDataLabel: string) {
  if (!date)
    return noDataLabel

  const parsedDate = new Date(date)
  return Number.isNaN(parsedDate.getTime())
    ? noDataLabel
    : parsedDate.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

export function ProductAvailability({
  availabilityDate,
}: Readonly<{
  availabilityDate: AvailabilityDate
}>) {
  const { t } = useTranslation()

  return (
    <section
      className="product-card-availability"
      data-testid="product-card_availability"
    >
      <div className="start-date" data-testid="availability_start-date">
        <span className="sr-only">
          {t('aria-label.availability-start-date')}
          :
          {' '}
        </span>
        <span aria-hidden="true">
          {t(
            'products-page.product-card.availability.start-date',
          )}
        </span>
        {formatDate(availabilityDate?.start_date, t('products-page.product-card.no-data'))}
      </div>
      <div className="end-date" data-testid="availability_end-date">
        <span className="sr-only">
          {t('aria-label.availability-end-date')}
          :
          {' '}
        </span>
        <span aria-hidden="true">
          {t('products-page.product-card.availability.end-date')}
        </span>
        {formatDate(availabilityDate?.end_date, t('products-page.product-card.no-data'))}
      </div>
    </section>
  )
}
